let authStoreModule = {
    namespaced: true,
    state: {
        token: [],
        access_token: '',
        refresh_token: '',
        access_expires_in: '',
        refresh_expires_in: '',
        state: '',
    },
    getters: {
        token(state) {
            console.log('auth module getters getToken');
            state.access_token = localStorage.getItem('access_token');
            return state.access_token;
            // var tokens = JSON.parse(localStorage.getItem('token'))
            // return tokens['access_token'] ? tokens['access_token'] : '';
        },
    },
    actions: {
        loadFromStorage(vm) {
            console.log('loadFromStorage');
            vm.state.token = JSON.parse(localStorage.getItem('token'))
            vm.state.access_token = localStorage.getItem('access_token') || '';
            vm.state.refresh_token = localStorage.getItem('refresh_token') || '';
            vm.state.access_expires_in = localStorage.getItem('access_expires_in') || '';
            vm.state.refresh_expires_in = localStorage.getItem('refresh_expires_in') || '';
            vm.state.state = localStorage.getItem('state') || '';
        },
        resetToken(state) {
            console.log('startreset token setter')
            state.commit('access_token', '')
            state.commit('refresh_token', '')
            state.commit('access_expires_in', 0)
            state.commit('refresh_expires_in', 0)
            state.state.token = '{}';
            console.log('end reset token setter')
        },
        setToken(state, data) {
            console.log('start token setter', state, data)
            state.commit('access_token', data.access_token);
            state.commit('refresh_token', data.refresh_token);
            state.commit('access_expires_in', data.expires_in);
            state.commit('refresh_expires_in', '');
            state.state.token = JSON.stringify(data.data);
            console.log('end token setter')
        }
    },
    mutations: {
        access_token(state, data) {
            state.access_token = data;
            localStorage.setItem('access_token', data);
        },
        refresh_token(state, data) {
            state.refresh_token = data;
            localStorage.setItem('refresh_token', data);
        },
        access_expires_in(state, data) {
            state.access_expires_in = Math.floor(Date.now()) + (data * 1000)
            localStorage.setItem('access_expires_in', state.access_expires_in);
        },
        refresh_expires_in(state, data) {
            state.refresh_expires_in = Math.floor(Date.now()) + (data * 1000)
            localStorage.setItem('refresh_expires_in', state.refresh_expires_in);
        },
    }
}
export default authStoreModule;